import { OperationsManagementRouteMap } from '@/new-router/operations-management'

const adminOperation = () => import('@/views/DataGraph/adminOperation')
const Home = () => import('@/views/Home/home')

export default {
  path: '/dataGraph',
  name: 'dataGraph',
  component: Home,
  meta: {
    title: '数据中台',
    icon: 'icon-data-graph',
    showSubiems: false,
    sort: 15,
    modules: 'dataGraph',
    permission: 'data:root',
  },
  children: [
    {
      path: 'adminOperation',
      name: 'adminOperation',
      component: adminOperation,
      meta: {
        sort: 1,
        title: '短信批量推送',
        active: ['adminOperation'],
        permission: 'data:operate',
        belong: [
          OperationsManagementRouteMap.OperationsManagement,
          OperationsManagementRouteMap.SystemSettings,
        ],
      },
    },
  ],
}
